import React from "react";
import { Box, Typography, Paper, Grid, Divider, Avatar } from "@mui/material";
import { FactCheck } from "@mui/icons-material";
import { useSelector } from "react-redux";

const SummaryPage = ({ formData, onBack, onNext }) => {
  const { items } = useSelector((state) => state?.packages?.booking);
  console.log("items", items);

  return (
    <Grid
      container
      justifyContent="center"
      sx={{ minHeight: "100vh", pt: 5, backgroundColor: "#eef2f7" }}
    >
      <Grid item xs={12} sm={10} md={8} lg={6}>
        <Paper
          elevation={6}
          sx={{
            borderRadius: 4,
            p: { xs: 3, sm: 4, md: 5 },
            background: "#fff",
          }}
        >
          {/* Header Section */}
          <Box textAlign="center" mb={4}>
            <Avatar
              sx={{
                bgcolor: "#1976d2",
                width: 56,
                height: 56,
                margin: "0 auto",
                mb: 1,
              }}
            >
              <FactCheck fontSize="medium" />
            </Avatar>
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ color: "#2c3e50", letterSpacing: 0.5 }}
            >
              Confirm Your Booking Details
            </Typography>
            <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ mt: 0.5 }}
            >
              Please review the information before proceeding
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Clinic, Package & Date Section */}
          <Box
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: 3,
              backgroundColor: "#e3f2fd",
              border: "1px solid #bbdefb",
              textAlign: "center",
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ color: "#1565c0", mb: 0.3 }}
            >
              {items?.data?.packageDetails.packageFacility || "Clinic Name"}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: "#1e88e5", fontWeight: 500 }}
            >
              Package: {items?.data?.packageDetails.packageName || "N/A"}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#0d47a1",
                fontWeight: 500,
                mt: 0.5,
                fontStyle: "italic",
              }}
            >
              Appointment Date:{" "}
              {formData.date
                ? new Date(formData.date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
            </Typography>
          </Box>

          {/* Patient Details Section */}
          {/* <Typography
            variant="h6"
            fontWeight={600}
            sx={{ mb: 2, color: "#2c3e50" }}
          >
            Patient Details
          </Typography> */}

          <Grid container spacing={2}>
            {[
              { label: "Full Name", value: items?.data.name },
              { label: "Gender", value: items?.data.gender },
              { label: "City", value: items?.data.city },
              { label: "Mobile Number", value: items?.data.mobileNo },
            ].map(({ label, value }, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#f0fff4ff",
                    border: "1px solid #cae2c0ff",
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    gutterBottom
                    sx={{ textTransform: "uppercase", fontWeight: 600 }}
                  >
                    {label}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight={500}
                    sx={{ color: "#2c3e50" }}
                  >
                    {value || "-"}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* <Box
            display="flex"
            justifyContent="space-between"
            mt={5}
            flexDirection={{ xs: "column", sm: "row" }}
            gap={2}
          >
            <Button
              variant="contained"
              endIcon={<Payment />}
              onClick={onNext}
              sx={{
                borderRadius: 2,
                px: 3,
                textTransform: "none",
              }}
              fullWidth
            >
              Proceed to Payment
            </Button>
          </Box> */}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default SummaryPage;
